import { HeaderState } from './types';

export function initialState(): HeaderState {
  return {
    breadcrumb: [],
  };
}
